import { useState } from "react";
const useFocus = (intialState = false) => {
  const [focused, set] = useState(intialState);
  return [
    focused,
    {
      onFocus: () => set(true),
      onBlur: () => set(false)
    }
  ];
};
export {
  useFocus as default
};
//# sourceMappingURL=useFocus.es.js.map
